import React from 'react';
import ArrowUp from '../../Images/chevron-up.svg';
import ArrowDown from '../../Images/chevron-down.svg';
import ArrowDefault from '../../Images/Chevron-default-icon.svg';
import { SortableKeys, SummarySortConfig } from './summaryTypes';

type Props = {
  columnKey: SortableKeys;
  className?: string;
  activeTab: 'assets' | 'pinned' | 'mapview';
  sortConfig: SummarySortConfig | null;
  pinnedSortConfig: SummarySortConfig | null;
  onRequestSort: (key: SortableKeys) => void;
};

type SortDirection = SummarySortConfig['direction'] | null;

const activeSortDirectionForColumn = (
  activeTab: Props['activeTab'],
  columnKey: SortableKeys,
  sortConfig: SummarySortConfig | null,
  pinnedSortConfig: SummarySortConfig | null
): SortDirection => {
  const config = activeTab === 'assets' ? sortConfig : pinnedSortConfig;
  if (!config || config.key !== columnKey) return null;
  return config.direction;
};

const sortIconPresentation = (direction: SortDirection) => {
  if (direction === 'asc') {
    return {
      src: ArrowUp,
      alt: 'Sort ascending',
      imgClass: 'sort-icon-img-up',
    };
  }
  if (direction === 'desc') {
    return {
      src: ArrowDown,
      alt: 'Sort descending',
      imgClass: 'sort-icon-img-down',
    };
  }
  return {
    src: ArrowDefault,
    alt: 'Sort',
    imgClass: 'sort-icon-img',
  };
};

const SummarySortIcon: React.FC<Props> = ({
  columnKey,
  className = '',
  activeTab,
  sortConfig,
  pinnedSortConfig,
  onRequestSort,
}) => {
  const direction = activeSortDirectionForColumn(
    activeTab,
    columnKey,
    sortConfig,
    pinnedSortConfig
  );
  const { src, alt, imgClass } = sortIconPresentation(direction);
  const sortClassSuffix = direction ? `sort-${direction}` : '';

  const requestSort = () => onRequestSort(columnKey);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    requestSort();
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    requestSort();
  };

  return (
    <div
      className={`table-sort-icon ${sortClassSuffix} ${className}`}
      tabIndex={0}
      role="button"
      aria-label={`Sort by ${columnKey}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      <img src={src} alt={alt} className={imgClass} />
    </div>
  );
};

export default SummarySortIcon;
